import { render, staticRenderFns } from "./webloyalty.vue?vue&type=template&id=c1246ed4"
import script from "./webloyalty.vue?vue&type=script&lang=ts"
export * from "./webloyalty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports